import { UPDATE_ITEM_FAILURE,
  UPDATE_ITEM_REQUESTED,
  UPDATE_ITEM_SUCCESS } from "../actions/item-action-types";

const initialState = {
  addItemStatus: "pending",
  items: [],
};

export default function items(state = initialState, {
  type, payload,
}) {
  switch (type) {
    case UPDATE_ITEM_REQUESTED:
      return {
        ...state,
        addItemStatus: "request",
      };
    case UPDATE_ITEM_SUCCESS:
      return {
        ...state,
        addItemStatus: "success",
        items: payload,
      };
    case UPDATE_ITEM_FAILURE:
      return {
        ...state,
        addItemStatus: "failed",
      };

    default:
      return state;
  }
}
